import { Action } from '@ngrx/store';
import {NewOrderParams} from '../purchase.model';

export enum OrderActionTypes {
  CreateOrder = '[Order] Create Order',
  LoadOrder = '[Order] Load Order'
}

export class CreateOrder implements Action {
  readonly type = OrderActionTypes.CreateOrder;
  constructor(public payload: NewOrderParams) {}
}

export class LoadOrder implements Action {
  readonly type = OrderActionTypes.LoadOrder;
}


export type OrderActions = CreateOrder
  | LoadOrder;
